import React from "react";
import { Box, Divider as MUIDivider } from "@material-ui/core";

const Divider = ({ disableGutters = false }) => (
  <Box paddingY={disableGutters ? 0 : 3}>
    <MUIDivider light />
  </Box>
);
export default Divider;